import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import loop from '../_loop-component';
import showStaticHtml from '../_show_static_html';
import partsSelecter from './_parts_selecter';
import partsEditer from './_parts_editor';
import copyPartsSelecter from './copy_parts_selecter/_index';
import addImagesConfig from './add_images_config/_index';
import linkSelecter from '../_link_selecter';
import itemSearch from '../_modal_item_search';

/**
 * 静的HTML編集コンポーネント
 */
export default {
    name: 'StaticHtmlEditor',
    template: '#static_html_editor_template',
    data() {
        return {
            // 編集エリアの切り替えアニメーションを実現するため再レンダリング用フラグ
            show_edit_area: true,
            // マウンテッドフラグ($refsで参照している箇所を表示待ちさせる為)
            mounted: false,
            // 文字数オーバーフラグ
            is_over_text_length: false,
            // 文字数オーバーになった際のメッセージ
            over_text_length_message: ''
        };
    },
    props: {
        // パーツタイプ build_store|item|custom_page
        type: {
            type: String,
            require: true,
            validator: function (value) {
                return ['build_store', 'item', 'custom_page'].indexOf(value) !== -1;
            }
        },
        // テンプレート
        prop_template: {
            type: Object,
            required: true,
        },
        // 各エリア定義
        areas_config: {
            type: Array,
            default: () => ([]),
        },
        // 編集ID(主に画像参照に使う)
        edit_id: {
            type: [String, Number],
            default: '',
            require: false
        },
        // 編集ブロック
        prop_edit_area: '',
        // 編集データ
        prop_edit_data: {
            type: Object,
            default: () => ({}),
        },
        // 連動フラグ
        prop_device_sync: {
            type: Boolean,
            required: false,
            default: false,
        },
        // 商品詳細画像(type=itemのみ)
        prop_lib_images_config: {
            type: Object,
            default: () => ({}),
            required: false,
        },
    },
    components: {
        // 静的HTMLを表示するコンポーネント
        'show-static-html': showStaticHtml,
        // 繰り返しコンポーネント
        'loop': loop,
        // 新規パーツ選択コンポーネント
        'parts-selecter': partsSelecter,
        // パーツ編集コンポーネント
        'parts-editer': partsEditer,
        // コピーパーツ選択コンポーネント
        'copy-parts-selecter': copyPartsSelecter,
        // 商品詳細画像を並べるモーダルコンポーネント
        'add-images-config': addImagesConfig,
        // リンク選択モーダルコンポーネント
        'link-selecter': linkSelecter,
        // 商品選択モーダルコンポーネント
        'item-search': itemSearch,
    },
    computed: {
        // テンプレート
        template: {
            get() {
                return this.prop_template;
            },
            set(value) {
                this.$emit('update:prop_template', value);
            },
        },
        // 編集ブロック(このコンポーネント用)
        editArea: {
            get() {
                return this.prop_edit_area;
            },
            set(value) {
                this.$emit('update:prop_edit_area', value);
            },
        },
        // 編集データ(このコンポーネント用)
        editData: {
            get() {
                return this.prop_edit_data;
            },
            set(value) {
                this.$emit('update:prop_edit_data', value);
            },
        },
        // 全体設定用データ(編集モーダルへ渡す)
        commonConfig: {
            get() {
                if (!Object.keys(this.editData).length) {
                    return;
                }

                return {
                    background: this.editData.background,
                    font_family: this.editData.font_family,
                    sync_data: this.editData.sync_data,
                    font_color: this.editData.font_color,
                    wrap_align: this.editData.wrap_align,
                };
            },
            set(value) {
                for (let key of Object.keys(value)) {
                    this.editData[key] = value[key];
                }
            },
        },
        // PC、SP連動設定用データ(編集モーダルへ渡す)
        syncConfig: {
            get() {
                return {device_sync: this.device_sync};
            },
            set(value) {
                this.device_sync = value.device_sync;
            },
        },
        // パーツが1つ以上登録されているか
        hasParts: function () {
            return (typeof this.editData.parts !== 'undefined' && this.editData.parts.length > 0);
        },
        // 編集エリアデータリスト
        areasData: function () {
            return this.areas_config.map((area) => {
                area.no_name = area.name;
                return area;
            });
        },
        // プレビュー幅の定義
        areaWidth: function () {
            for (let area of this.areasData) {
                if (area.key === this.editArea) {
                    return area.width;
                }
            }
            return 0;
        },
        // 前の編集エリア
        prevAreaData: function () {
            const last = this.areasData.length - 1;
            for (let i of Object.keys(this.areasData)) {
                if (this.areasData[i].key === this.editArea && i > 0) {
                    const prevIndex = Number(i) - 1;
                    return this.areasData[prevIndex];
                }
            }
            return this.areasData[last];
        },
        // 次の編集エリア
        nextAreaData: function () {
            const last = this.areasData.length - 1;
            for (let i of Object.keys(this.areasData)) {
                if (this.areasData[i].key === this.editArea && i < last) {
                    const nextIndex = Number(i) + 1;
                    return this.areasData[nextIndex];
                }
            }
            return this.areasData[0];
        },
        // 連動フラグ
        device_sync: {
            get() {
                return this.prop_device_sync;
            },
            set(value) {
                this.$emit('update:prop_device_sync', value);
            },
        },
        // スマホとの連動時、各パーツの専用設定項目の表示フラグ(device_sync、編集エリア考慮する)
        isShowDeviceSyncEditArea: function () {
            if (!this.device_sync || this.editArea === 'header' || this.editArea === 'footer') {
                return false;
            }
            return true;
        },
        // スマホとの連動設定ボタンの表示フラグ (ストア構築のPCトップ編集エリアが対象)
        isShowSyncControllerBtn: function () {
            return (this.type === 'build_store' && this.editArea === 'freetext');
        },
        // スマホとの連動設定ボタンの表示フラグ (ストア構築のPCトップ編集エリアが対象)
        isShowAddDescriptionImagesBtn: function () {
            return (this.type === 'item');
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    // マウンテッドフラグを更新
    beforeCreate: function() {
        this.mounted = false;
    },
    mounted: function() {
        this.mounted = true;
    },
    watch: {
        // 文字数オーバーフラグを親にも通知
        over_text_length_message: function () {
            this.emitOverTextLength();
        }
    },
    emits: [
        'update:prop_template',
        'update:prop_edit_area',
        'update:prop_edit_data',
        'update:prop_device_sync',
        'emit-over-text-length',
    ],
    methods: {
        // パーツを追加する
        addPartsData: function (partsData, index) {
            this.editData.parts.splice(index, 0, partsData);
            this.getStaticHtml();
        },
        /**
         * パーツを複数追加する
         *
         * @param {Array} partsDataArr partsData配列
         * @param {Boolean} isTakeOver 既存パーツを残すフラグ
         */
        addPartsDataArr: function (partsDataArr, isTakeOver) {
            this.editData.parts = (isTakeOver === true ? partsDataArr.concat(this.editData.parts) : partsDataArr);
            this.getStaticHtml();
        },
        // パーツデータ更新
        updatePartsData: function (partsData, index) {
            this.editData.parts[index].data = partsData;
            this.getStaticHtml();
        },
        // パーツをコピーする
        copyParts: function(index) {
            this.$refs.loop.copy(index);
            this.getStaticHtml();
        },
        // パーツを削除する
        removeParts: function (index) {
            this.$refs.loop.remove(index);
            this.getStaticHtml();
        },
        // パーツを選択画面を開く
        openPartsSelecter: function (index) {
            this.$refs.parts_selecter.show(index);
        },
        // パーツ編集画面を開く
        openPartsEditer: function (index) {
            const partsData = _.cloneDeep(this.editData.parts[index]);
            this.$refs.parts_editer.show(partsData, index);
        },
        // コピーされたパーツを追加する
        addCopiedParts: function (copiedParts, copiedDesign) {
            copiedParts.reverse().forEach(part => this.addPartsData(part, 0));
            if (copiedDesign) {
                const design = {...this.editData, ...copiedDesign};
                this.editData = design;
            }
        },
        // editAreaを変更する(アニメーション付き)
        changeEditArea: async function (editArea) {
            this.show_edit_area = false;
            await this.$_sleep(500);
            this.editArea = editArea;
            this.show_edit_area = true;
        },
        // 商品コーナーパーツの商品を全て更新する
        bulkUpdateAllItems: async function () {
            this.$_loading();
            try {
                this.editData.parts =  await Promise.all(this.editData.parts?.map(async (part) => {
                    // 商品パーツのみ対象
                    if (part.key !== 'item') return part;
                    // 各商品を更新
                    part.data.main = await Promise.all(part.data.main.map(async (item) => {
                        const item_code = item.item_code;
                        if (!item_code) return item;

                        const response = await axios.get('/search_items', {
                            params: {
                                hits: 1,
                                page: 1,
                                keyword: item_code,
                                stock_flag: 'all_items',
                                not_keyword: '',
                                min_price: '',
                                max_price: '',
                                search_mode: 'item_code',
                                page_key: '',
                                sort: '',
                                add_tax: '1',
                                is_item_update: '1'
                            }
                        });

                        if (response.data.status !== 'OK') return item;

                        const updatedItem = response.data.data.items.filter((item) => item.item_code === item_code)?.[0];
                        if (!updatedItem) return item;
                        return updatedItem;
                    }));
                    return part;
                }));
                this.getStaticHtml();
                // パーツエディターが開いている場合開きなおす
                const currentPartIndex = this.$refs.parts_editer.index ?? null;
                if (currentPartIndex !== null) this.openPartsEditer(currentPartIndex);
            } catch (e) {
                console.error(e);
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: this.exception_error_message,
                }, this.$parent);
            } finally {
                this.$_unloading();
            }
        },
        // 静的HTML更新
        getStaticHtml: async function () {
            await this.$nextTick();
            // フラッシュメッセージを初期化
            this.clearFlashMessage(null, this.$parent);
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await axios.post('/get_static_html', {
                    _method: 'POST',
                    edit_id: this.edit_id,
                    type: this.type,
                    template: this.template,
                    device_sync: this.device_sync,
                });

                // 静的HTMLを更新
                this.template = response.data.template;
                // 文字数オーバーフラグを更新
                this.is_over_text_length = (response.data.message) ? true : false;
                // 文字数オーバーメッセージ
                this.over_text_length_message = response.data.message;
                // メッセージは空にする
                message = '';
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },

        // -------------------------
        // emit
        // -------------------------

        // 文字数オーバーフラグを親に通知
        emitOverTextLength: function () {
            this.$emit('emit-over-text-length', this.is_over_text_length, this.over_text_length_message);
        },
    }
};
